import React from 'react';

import {getTimeZones} from '@vvo/tzdb';
import {keyBy} from 'lodash';
import {useTranslation} from 'react-i18next';

import TimezoneAutocomplete from './TimezoneAutocomplete';

import {buildTzArr, findTzArrKey} from 'Utils';

const timeZonesWithUtc = getTimeZones({includeUtc: true});

/**
 * TimeZoneWidget.js
 * Displays which timezone the appointment is currently in.
 * @param {Object} props
 * @return {ReactElement}
 */
export default function TimeZonePicker(props) {
  const {locked, onChange, sx, value} = props;
  const {t} = useTranslation();

  const timezoneOptions = buildTzArr(timeZonesWithUtc, t);
  const indexedOpts = keyBy(timezoneOptions, (o) => o.name);

  const autocompleteValue = React.useMemo(() => {
    return indexedOpts[findTzArrKey(timezoneOptions, value)];
  }, [indexedOpts, timezoneOptions, value]);

  return (
    <TimezoneAutocomplete
      sx={sx}
      locked={locked}
      options={timezoneOptions}
      value={autocompleteValue}
      onChange={(option) => onChange(option.name)}
    />
  );
}

